<template>
<el-form :inline="true" class="demo-form-inline" :label-position="labelPosition" ref="myForm">
    <el-form-item label="Species">
        <el-select v-model="species" placeholder="Please select species" style="width:200px;" @change="handleSpeciesChange">
            <el-option v-for="option in speciesOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
    </el-form-item>
    <el-form-item label="Tissue">
        <el-select v-model="tissue" placeholder="Please select tissue" style="width:200px;">
            <!-- <el-option v-for="option in tissueOptions" :key="JSON.stringify(option.value)" :label="option.label" :value="option.value"></el-option> -->
            <el-option v-for="(option, index) in tissueOptions" :key="index" :label="option.label" :value="option.value"></el-option>
        </el-select>
    </el-form-item>
    <el-form-item label="Gene">
      <el-autocomplete
        v-model="gene"
        placeholder="Please enter gene"
        style="width:200px;"
        :fetch-suggestions="querySearch"
        @select="handleGeneSelect"
      ></el-autocomplete>
    </el-form-item>
    <el-form-item>
    <el-button class="search-button" size="small" type="primary" @click="handleSearch" style="width:200px;">search</el-button>
    </el-form-item>
    <el-form-item>
    <el-button class="search-button" size="small" type="primary" @click="resetForm" style="width:200px;">reset</el-button>
    </el-form-item>
</el-form>
</template>

<script>
export default {
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            labelPosition: 'top',
            species: 'human',//记得和Relationship1中的created一致
            tissue:'mesendoderm',
            gene:'Tead1',
            speciesOptions: [
                    { label: 'human', value: 'human' },
                    { label: 'mouse', value: 'mouse' }
            ],
            tissueOptions: [],
            uniqueGeneOptions: new Set(), // 添加这行进行初始化
        };
    },
    created() {
        this.updateTissueOptions();
    },
    methods: {
        // 新增基因搜索方法
        querySearch(queryString, cb) {
        if (!queryString) {
            cb([]);
            return;
        }
        // 发送异步请求到后端，获取匹配的基因选项
        this.$axios.get(this.url + "Geneen" + "/", { params: { query: queryString } })
            .then(response => {
            // 使用 Set 来保存不重复的基因
            this.uniqueGeneOptions = new Set(response.data.map(item => item.Gene));

            // 将 Set 转为数组，以便提供给 el-autocomplete
            const geneArray = Array.from(this.uniqueGeneOptions).map(gene => ({ value: gene, label: gene }));

            // 模糊搜索，筛选出包含用户输入的基因作为提示
            const filteredGenes = geneArray.filter(item => item.label.toLowerCase().includes(queryString.toLowerCase()));
            
            cb(filteredGenes);
            })
            .catch(error => {
            console.error('Error fetching gene options:', error);
            cb([]);
            });
        },
        // 处理基因选择
        handleGeneSelect(item) {
            if (item) {
                this.gene = item.value;
            }
        },
        handleSpeciesChange() {
            // 物种改变时更新组织类型选项
            this.updateTissueOptions();
        },
        updateTissueOptions() {
            const selectedSpecies = this.species;
            // 根据选择的物种更新组织类型选项
            if (selectedSpecies === 'human') {
                this.tissueOptions = [
                    { label: 'mesendoderm', value: ['hESC','PreME','ME',] } ,
                    { label: 'definitive endoderm', value: ['hESC','PreME','DE',] } ,
                    { label: 'primodridal germ cells', value: ['hESC','hPGCLC','hPGC',] } ,
                    { label: 'cardiomyocyte', value: ['0d_ESC','2d_mesoderm','5d_cardiac_mesoderm',
                    '7d_cardiac_progenitor_cells','15d_primitive_cardiomyocite','80d_ventricular_cardiomyocyte'] } ,
                    { label: 'erythrocyte', value: ['HSPC','EryPro','EryPre',] } ,
                ];
            } else if (selectedSpecies === 'mouse') {
                this.tissueOptions = [
                    { label: 'cardiomyocyte', value: ['CESC','MES','CP','CM'] } ,
                    { label: 'sperm', value: ['Thy1','KIT','PS','RS'] } ,
                    { label: 'spermatids', value: ['Spermatogonia','Spermatocytes','Spermatids'] } ,
                    { label: 'embryonic facial prominence', value: ['embryonic facial prominence embryo (11.5 days)','embryonic facial prominence embryo (12.5 days)',
                    'embryonic facial prominence embryo (13.5 days)','embryonic facial prominence embryo (14.5 days)','embryonic facial prominence embryo (15.5 days)'] } ,
                    { label: 'forebrain', value: ['forebrain embryo (11.5 days)','forebrain embryo (12.5 days)','forebrain embryo (13.5 days)','forebrain embryo (14.5 days)',
                    'forebrain embryo (15.5 days)','forebrain embryo (16.5 days)','forebrain postnatal (0 days)'] } ,
                    { label: 'heart', value: ['heart embryo (11.5 days)','heart embryo (12.5 days)','heart embryo (14.5 days)','heart embryo (15.5 days)',
                    'heart embryo (16.5 days)','heart postnatal (0 days)'] } ,
                    { label: 'hindbrain', value: ['hindbrain embryo (11.5 days)','hindbrain embryo (13.5 days)','hindbrain embryo (14.5 days)','hindbrain embryo (15.5 days)',
                    'hindbrain embryo (16.5 days)','hindbrain postnatal (0 days)'] } ,
                    { label: 'intestine', value: ['intestine embryo (14.5 days)','intestine embryo (15.5 days)','intestine embryo (16.5 days)','intestine postnatal (0 days)'] } ,
                    { label: 'kidney', value: ['kidney embryo (14.5 days)','kidney embryo (15.5 days)','kidney embryo (16.5 days)','kidney postnatal (0 days)'] } ,
                    { label: 'limb', value: ['limb embryo (11.5 days)','limb embryo (12.5 days)','limb embryo (13.5 days)','limb embryo (14.5 days)',
                    'limb embryo (15.5 days)'] } ,
                    { label: 'liver', value: ['liver embryo (11.5 days)','liver embryo (12.5 days)','liver embryo (13.5 days)',
                    'liver embryo (14.5 days)','liver embryo (15.5 days)','liver embryo (16.5 days)','liver postnatal (0 days)'] } ,
                    { label: 'lung', value: ['lung embryo (14.5 days)','lung embryo (15.5 days)','lung embryo (16.5 days)','lung postnatal (0 days)'] } ,
                    { label: 'midbrain', value: ['midbrain embryo (11.5 days)','midbrain embryo (12.5 days)','midbrain embryo (13.5 days)',
                    'midbrain embryo (14.5 days)','midbrain embryo (15.5 days)','midbrain embryo (16.5 days)','midbrain postnatal (0 days)'] } ,
                    { label: 'neural tube', value: ['neural tube embryo (11.5 days)','neural tube embryo (12.5 days)','neural tube embryo (13.5 days)',
                    'neural tube embryo (14.5 days)','neural tube embryo (15.5 days)'] } ,
                    { label: 'stomach', value: ['stomach embryo (14.5 days)','stomach embryo (15.5 days)','stomach embryo (16.5 days)','stomach postnatal (0 days)',] } ,
                ];
            } else {
                // 其他物种的选项...
                this.tissueOptions = [];
            }
        },
        handleSearch() {
            if (!this.species || !this.tissue) {
                this.$message.error('Please complete the input field.');
                return;
            }
            const params = {
                Species: this.species,
                Tissue: this.tissue,
                Gene: this.gene,
            };
            this.$emit('search', params); // 触发名为'search'的事件，并传递参数
        },
        resetForm() {
            this.species = '';
            this.tissue = [];
            // 重置物种后再次触发组织选项更新
            this.handleSpeciesChange();
        },
    },
};
</script>

<style scoped>
.demo-form-inline {
    font-weight: bold;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
}
.search-button {
    color: #F1F7E7;
    font-size: medium;
    float: left;
    background-color: #2C3E50;
    width: 100px;
    border: 1px solid #2C3E50; /* 设置边框为与背景色一致 */
}
</style>


// WEBPACK FOOTER //
// src/components/home/Geneselect.vue